import React, { useEffect } from 'react'
import { Button } from '@corratech/pylot-ui'
import { useRouter } from 'next/router'
import { FilterWrapperProps } from '../FilterTypes'
import s from '@commonStyles/HorizontalFilter.module.scss'
import cn from 'classnames'
import { useTranslation } from 'next-i18next/pages'
import { Cross } from '@components/icons'

export const HorizontalFilter = (props: FilterWrapperProps): JSX.Element => {
    const { t } = useTranslation(['plp'])
    const router = useRouter()

    const isSearchPage = router.pathname === '/search'

    const {
        subCategories,
        filtersApplied,
        applyFilter,
        filtersVisible,
        setFiltersVisible,
        filtersList,
        appliedFilterList,
        className
    } = props

    // 🚫 Scroll lock como en Sort
    useEffect(() => {
        if (filtersVisible) {
            const scrollY = window.scrollY
            document.body.style.position = 'fixed'
            document.body.style.top = `-${scrollY}px`
            document.body.style.left = '0'
            document.body.style.right = '0'
        } else {
            const scrollY = document.body.style.top
            document.body.style.position = ''
            document.body.style.top = ''
            document.body.style.left = ''
            document.body.style.right = ''
            if (scrollY) {
                window.scrollTo(0, parseInt(scrollY || '0') * -1)
            }
        }

        return () => {
            document.body.style.position = ''
            document.body.style.top = ''
            document.body.style.left = ''
            document.body.style.right = ''
        }
    }, [filtersVisible])

    return (
        <div className={s['horizontal-filter-menu']}>
            {filtersApplied > 0 && (
                <div className={s['filter-items-wrapper']}>
                    <div className={s['filter-wrapper']}>
                        <div className={s['filtered-by']}>
                            {t('Filtered by:')}
                        </div>
                        <div className={s['selected-items-list']}>
                            <span
                                onClick={() => applyFilter()}
                                className={s['selected-items-clear-all']}
                                aria-hidden="true"
                            >
                                {t('Clear all')}
                            </span>
                        </div>
                    </div>
                    {appliedFilterList}
                </div>
            )}

            {filtersVisible && (
                <>
                    {/* Overlay para cerrar al hacer click fuera */}
                    <div
                        className={s['filter-overlay']}
                        onClick={() => setFiltersVisible(false)}
                        aria-hidden="true"
                    />

                    {/* Panel lateral fijo */}
                    <div
                        className={cn(
                            s['layered-navigations'],
                            isSearchPage && s['layered-navigations-srp'],
                            filtersVisible && s['open'],
                            className
                        )}
                    >
                        <div className={s['filter-mob']}>
                            <Button
                                variant="link"
                                className={s['filter-mob-close']}
                                onClick={() => setFiltersVisible(false)}
                            >
                                <Cross />
                            </Button>
                        </div>
                        <div className={s['filter-body']}>
                            <div className={s['filter-body-row']}>
                                <div className={s['filter-body-title']}>
                                    {t('Filter by:')}
                                </div>
                                <Button
                                    variant="link"
                                    onClick={() => setFiltersVisible(false)}
                                >
                                    <Cross />
                                </Button>
                            </div>
                            <div>{subCategories}</div>
                            <ul className={s['filters-list']}>{filtersList}</ul>
                            <div className={cn(s['selected-items-list'])}>
                                <Button
                                    variant="secondary"
                                    onClick={() => setFiltersVisible(false)}
                                >
                                    {t('toolbar|Apply')}
                                </Button>
                                <Button
                                    variant="secondary"
                                    disabled={filtersApplied === 0}
                                    onClick={() => applyFilter()}
                                >
                                    {t('toolbar|Reset')}
                                </Button>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    )
}
